import {FormControl} from '@angular/forms';

export function anyValue(c: FormControl) {
    if (c.value === null || c.value === undefined) {
        return {
            message: 'lta-errors.required'
        };
    } else {
        return null
    }
}
